const NATIVE_AD_UNIT_ID = {
	kakaotalkTab: CAFEAPP.IS_DEV === 'true' ? 'DAN-JmztI9zQu0fk0dTu' : 'DAN-wutSGuA3HJxI1ike',
	daumapp: CAFEAPP.IS_DEV === 'true' ? 'DAN-1VUIseCQ9tJEcRsv' : 'DAN-fBVp0AKaZ4xbdOpA'
}

function nativeAdTemplate(svc, idx) {
	const unitId = NATIVE_AD_UNIT_ID[svc];

	return `
		<li adfit-unit-id="${unitId}" adfit-unit-idx="${idx}">
			<div class="hotview_wrap">
				<a class="thumb_hotview" adfit-landing-url adfit‐target‐self>
					<img alt="썸네일 이미지" class="img_thumb" adfit-image-width="322" adfit-image-height="232" adfit-main-img-url>
				</a>
				<span class="detail_hotview">
					<a class="desc_hotview"><span adfit-title></span></a>
					<span class="ad_profile_name_wrap">
						<a adfit-landing-url adfit-ad-info target="_blank" class="ad_mark"><span class="sr_only">AD</span></a>
						<a adfit-landing-url target="_blank" class="ad_profile_name"><span adfit-profile-name></span></a>
					</span>
				</span>
			</div>
		</li>
	`;
}

export default function (svc, count, callback) {
	const html = [...Array(count).keys()].reduce((html, idx) => html + nativeAdTemplate(svc, idx), '');

	return new AdfitNativeAds({
		unitId: NATIVE_AD_UNIT_ID[svc],
	}).renderAs(html, callback);
}
